import * as fromRoot from '../app.state';

import { createFeatureSelector, createSelector } from '@ngrx/store';
import { DiscountReportActions, DiscountReportActionTypes } from './discount-report.actions';
import { IReport } from 'src/app/models/Report/Components/IReport';
import { IGardiffStoreSliceBase } from 'src/app/models/IGardiffStoreSliceBase';
import { GardiffStoreSliceStatus } from 'src/app/models/IGardiffStoreSliceStatus';
import { DiscountReportParameters } from 'src/app/models/Report/ReportParameters/IDiscountReportParameters';

export interface State extends fromRoot.State {
  DiscountReports: DiscountReportState;
}

export interface DiscountReportState extends IGardiffStoreSliceBase {
  DiscountReportParameters: DiscountReportParameters;
  DiscountReport: IReport;
  downloadedPDF: ArrayBuffer;
  downloadedXLS: ArrayBuffer;
}

const initialState: DiscountReportState = {
  DiscountReportParameters: new DiscountReportParameters(),
  DiscountReport: null,
  downloadedPDF: null,
  downloadedXLS: null,
  apiError: null,
  status: new GardiffStoreSliceStatus()
};

// create the selectors
const getDiscountReportFeatureState = createFeatureSelector<DiscountReportState>('discountReport');
export const getDiscountReportState = createSelector(
    getDiscountReportFeatureState,
    state => state
);

export const getParameters = createSelector(
    getDiscountReportFeatureState,
    state => state.DiscountReportParameters
);

export const getDiscountReport = createSelector(
    getDiscountReportFeatureState,
    state => state.DiscountReport
);

export const getPDFFile = createSelector(
    getDiscountReportFeatureState,
    state => state?.downloadedPDF
  );

export const getXLSFile = createSelector(
  getDiscountReportFeatureState,
  state => state?.downloadedXLS
);

export const getApiError = createSelector(
  getDiscountReportFeatureState,
  state => state.apiError
);

export const getStatus = createSelector(
  getDiscountReportFeatureState,
  state => state.status
);

export function reducer(state: DiscountReportState = initialState, action: DiscountReportActions): DiscountReportState {
    switch (action.type) {
        case DiscountReportActionTypes.LoadDiscountReport:
            return {
                ...state,
                DiscountReportParameters: action.payload,
                DiscountReport: null,
                apiError: null,
                status: null
            };

        case DiscountReportActionTypes.LoadDiscountReportSuccessful:
            return {
                ...state,
                DiscountReport: action.payload,
                apiError: null,
                status: new GardiffStoreSliceStatus(true)
            };

        case DiscountReportActionTypes.LoadDiscountReportFailed:
            return {
                ...state,
                DiscountReport: null,
                apiError: action.payload,
                status: new GardiffStoreSliceStatus()
            };

        case DiscountReportActionTypes.ResetStore:
          initialState.DiscountReportParameters.clearParameters()
            return {
                ...state,
                DiscountReportParameters : new DiscountReportParameters(),
                DiscountReport: initialState.DiscountReport,
                apiError: initialState.apiError,
                status: initialState.status
            };

        case DiscountReportActionTypes.SaveSearchParameters:
            return {
                ...state,
                DiscountReportParameters: action.payload
            };

        case DiscountReportActionTypes.DownloadPDF:
          return {
              ...state,
              downloadedPDF: null,
          };

        case DiscountReportActionTypes.DownloadPDFSuccessful:
            return {
                ...state,
                apiError: null,
                downloadedPDF: action.payload,
            };

        case DiscountReportActionTypes.DownloadPDFFailed:
            return {
                ...state,
                apiError: action.payload,
                downloadedPDF: null
            };

        case DiscountReportActionTypes.DownloadXLS:
            return {
                ...state,
                downloadedXLS: null,
            };

        case DiscountReportActionTypes.DownloadXLSSuccessful:
            return {
                ...state,
                apiError: null,
                downloadedXLS: action.payload,
            };

        case DiscountReportActionTypes.DownloadXLSFailed:
            return {
                ...state,
                apiError: action.payload,
                downloadedXLS: null
            };

        case DiscountReportActionTypes.CleanUpFileBuffer:
            return {
                ...state,
                downloadedPDF: initialState.downloadedPDF,
                downloadedXLS: initialState.downloadedXLS
            };

        default:
            return state;
    }
}
